import { render, staticRenderFns } from "./SplashPages.vue?vue&type=template&id=cbc632f2&scoped=true"
import script from "./SplashPages.vue?vue&type=script&lang=js"
export * from "./SplashPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc632f2",
  null
  
)

export default component.exports